import { render } from "./Orcamento.vue?vue&type=template&id=b22e224e"
import script from "./Orcamento.vue?vue&type=script&lang=ts"
export * from "./Orcamento.vue?vue&type=script&lang=ts"
script.render = render

export default script